const TEAMS = [
    {
        'imageSrc':require('assets/img/team/andy-fourie.jpeg'),
        'name':'Andy Fourie',
        'position':'Professor',
        'linkedInLink':'https://au.linkedin.com/in/andy-fourie-b07ab210',
        'researchLink':'https://research-repository.uwa.edu.au/en/persons/andy-fourie'
    },
    {
        'imageSrc':require('assets/img/team/cristina-vulpe.webp'),
        'name':'Cristina Vulpe',
        'position':'Research Fellow',
        'linkedInLink':'https://au.linkedin.com/in/cristina-vulpe-19b896b0',
        'researchLink':'https://research-repository.uwa.edu.au/en/persons/cristina-vulpe'
    },
    {
        'imageSrc':require('assets/img/team/jinglong-gao.jpeg'),
        'name':'Jinglong Gao',
        'position':'Research Associate',
        'linkedInLink':'https://au.linkedin.com/in/jinglong-gao-b1140063',
        'researchLink':'https://research-repository.uwa.edu.au/en/persons/jinglong-gao'
    },
    {
        'imageSrc':require('assets/img/team/alexandra-halliday.jpeg'),
        'name':'Alexandra Halliday',
        'position':'PhD Student',
        'linkedInLink':'https://www.linkedin.com/in/alexandra-halliday/',
        'researchLink':''
    }
];

export default TEAMS;